import Icon from '../../components/Icon.vue'

Icon.register({"brands/modx":{"width":448,"height":512,"paths":[{"d":"M356 241.8L392.7 265.5V480L259.7 396.2 356 241.8zM440 75H226.3L203.3 112.8 356.8 209.3 440 75zM351 217.8L55.2 32V246.5L101.2 275.5 351 217.8zM97 294.2L8 437H221.7L346.7 236.5 97 294.2z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/modx.js
// module id = iY5V
// module chunks = 0